import { createLucideIcon } from "lucide-react";

export const PlusCircle = createLucideIcon(
    "PlusCircle",
    [
        [
            "path",
            {
                d: "M12 8V16",
                key: "1wydb5",
            },
        ],
        [
            "path",
            {
                d: "M16 12H8",
                key: "1fr5h0",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
